import React, { Component } from "react";
import { monthlyData, productNames } from "../SubscriptionModule/utils";
import "./SubscriptionPage.scss";
import Radio from "semantic-ui-react/dist/es/addons/Radio";
import Dropdown from "semantic-ui-react/dist/es/modules/Dropdown";
import { connect } from "react-redux";
import { fetchPackageDetails, getStripeURL } from "../../actions/subscriptionAction";
import { ReactComponent as ErrorIcon } from "../SubscriptionModule/BillingComponents/payment-failed.svg";
import { ReactComponent as TickIcon } from "../../assets/svg/progress-completed.svg";
// import { ReactComponent as TickIcon } from "../../assets/svg/progress-completed.svg";
import Icon from "semantic-ui-react/dist/es/elements/Icon";
import Loader from "semantic-ui-react/dist/es/elements/Loader";
import { ReactComponent as SearchIcon } from "../../assets/svg/search.svg";
import { ReactComponent as CloseIcon } from "../../assets/svg/close.svg";
import Modal from "../UIComponents/CustomModal/Modal";
import { switchAccountDetails } from "../../actions/globalAction";
import { toast } from "react-toastify";
import { Link, Redirect } from "react-router-dom";

class SubscriptionPage extends Component {
    constructor(props) {
        super(props);

        const urlParams = new URLSearchParams(props.location.search);
        const error = urlParams.get("error");

        this.state = {
            package: "starter",
            cycle: "year",
            error: error === "true",
            toggleFeatures: true,
            submitting: false,
            companyName: props.company.company_name !== "" ? props.company.company_name : props.company.company_identifier,
            linked_companies: [],
            searchCompany: "",
            selectedAccount: "",
            showModal: false,
        };
    }

    componentDidMount() {
        this.props.fetchPackageDetails();
        // zE("webWidget", "updateSettings", { color: { theme: "#00bfa3" } });
        zE("webWidget", "show");

        if (sessionStorage.getItem("accountChanged")) {
            toast.success("Successfully logged into the New Account");
            sessionStorage.removeItem("accountChanged");
        }

        let linked_companies = [];
        if (this.props.all_companies && this.props.all_companies.length > 1) {
            this.props.all_companies.map((x) => {
                let name = x.name ? x.name : x.company_identifier;
                if (!linked_companies.some((e) => e.name === name)) linked_companies.push({ name, id: x.lite_company_id });
            });
        }
        linked_companies = linked_companies.sort(function (a, b) {
            return a.name.localeCompare(b.name);
        });
        this.setState({ linked_companies });
    }

    componentDidUpdate(prevProps) {
        if (this.props.newAccessToken && prevProps.newAccessToken !== this.props.newAccessToken) {
            sessionStorage.setItem("accountChanged", true);
            history.go(0);
        }

        if (prevProps.all_companies !== this.props.all_companies && this.props.all_companies) {
            let linked_companies = [];
            if (this.props.all_companies && this.props.all_companies.length > 1) {
                this.props.all_companies.map((x) => {
                    let name = x.name ? x.name : x.company_identifier;
                    if (!linked_companies.some((e) => e.name === name)) linked_companies.push({ name, id: x.lite_company_id });
                });
            }
            linked_companies = linked_companies.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
            this.setState({ linked_companies });
        }
    }
    componentWillUnmount() {
        zE("webWidget", "close");
        zE("webWidget", "hide");
    }

    filteredSearch = (linked_companies) => {
        if (this.state.searchCompany == "") return linked_companies;
        if (this.state.searchCompany.length == 1) {
            let filtered_companies = linked_companies.filter((c) => c.name.toLowerCase().charAt(0) == this.state.searchCompany.toLowerCase());
            if (filtered_companies.length) {
                return filtered_companies;
            } else {
                return [{ name: "No company found" }];
            }
        } else {
            let filtered_companies = linked_companies.filter((c) => c.name.toLowerCase().includes(this.state.searchCompany.toLowerCase()));
            if (filtered_companies.length) {
                return filtered_companies;
            } else {
                return [{ name: "No company found" }];
            }
        }
    };

    truncatedName = (text) => {
        let name = text;
        if (name.length > 40) {
            name = name.join("").substring(0, 40 - 3) + "...";
            return name;
            //    return <Popup inverted trigger={<span className="full-name-popup">{name}</span>} content={() => this.fullName(text)} position="right center" />;
        } else {
            return text.join("");
        }
    };

    searchCompanyName = (e) => {
        this.setState({
            searchCompany: e.target.value,
        });
    };

    tryAgain = () => {
        this.setState({ error: false });
        this.props.history.replace("/subscription");
    };

    checkout = () => {
        if (!this.props.packages[this.state.package]) return;
        let data = {
            price_id: this.props.packages[this.state.package][this.state.cycle]?.id,
            success_url: window.location.origin + "/subscription/success",
            error_url: window.location.origin + "/subscription/error",
        };

        this.setState({ submitting: true });

        this.props
            .getStripeURL(data)
            .then((res) => {
                if (res?.value?.data?.session_url) {
                    window.location.href = res.value.data.session_url;
                }
                this.setState({ submitting: false });
            })
            .catch((err) => this.setState({ submitting: false }));
    };

    getItems = () => {
        const iconUrl = (val) => {
            if (val === "tick-green") return <TickIcon />;
            else if (val === "tick-yellow") return <img src={`https://www.radarr.com/wp-content/uploads/2022/01/tick-yellow.svg`} />;
            else return <img src={"https://www.radarr.com/wp-content/uploads/2022/01/cross.svg"} />;
        };

        let elements = [];
        monthlyData.forEach((d, i) => {
            if (d[this.state.package].color !== "green") return null;
            elements.push(
                <div key={i + d.name} className="checkout-current-package-item">
                    <div className="query-row">
                        <div className={`bullet-icon ${d[this.state.package].color}`}>{iconUrl(d[this.state.package].icon)}</div>
                        <div className="info">
                            <p className="query-name">{d.name}</p>
                            <p> {d[this.state.package].content}</p>
                        </div>
                    </div>
                </div>,
            );
        });

        return (
            <>
                <div className="column-right">{elements.slice(0, elements.length / 2)}</div>
                <div className="column-left">{elements.slice(elements.length / 2)}</div>
            </>
        );
    };

    setSwitchModal = (show) => {
        this.setState({
            ...this.state,
            showModal: show,
        });
    };

    renderSwitchModal = () => {
        let company_id =
            this.props.all_companies.find((c) => (c.name || c.company_identifier) == this.state.selectedAccount.toString()) &&
            this.props.all_companies.find((c) => (c.name || c.company_identifier) == this.state.selectedAccount.toString()).id;
        let company_name = this.props.company.user_name;

        return (
            <Modal show={this.state.showModal} onClose={() => this.setSwitchModal(false)}>
                <Modal.Header>Switch Company</Modal.Header>
                <Modal.Content style={{ textAlign: "center" }}>
                    Are you sure you want to switch the company from <br />
                    <b>{this.truncatedName(this.state.companyName.split(""))}</b> <br /> to <br />
                    <b>{this.truncatedName(this.state.selectedAccount.split(""))}</b> ?
                </Modal.Content>
                <Modal.Actions>
                    <Modal.ActionButton className="block-button" normal onClick={() => this.setSwitchModal(false)}>
                        Cancel
                    </Modal.ActionButton>
                    <Modal.ActionButton
                        className="block-button switch_btn"
                        filled
                        onClick={() => {
                            this.props.switchAccountDetails(company_id);
                            this.setSwitchModal(false);
                        }}>
                        Switch
                    </Modal.ActionButton>
                </Modal.Actions>
            </Modal>
        );
    };

    render() {
        if (this.state.error) {
            return (
                <div className="subscription-page subscription-error">
                    <ErrorIcon />
                    <p>Payment failed</p>
                    <button className="submitButton" onClick={this.tryAgain}>
                        Try Again
                    </button>
                </div>
            );
        }

        return (
            <div className="subscription-page">
                <Redirect to="/billing/plans" />
                {/* <div className="signup-steps">
                    <span className="past">1</span>
                    <span className="past">2</span>
                    <span className="current">3</span>
                </div> */}
                <div className="subscription-contents">
                    <div className="top__heading__container">
                        <h2 className="heading__align__center">Upgrade your plan and get more features</h2>
                        {this.props.packageObj?.package_code === "free" && this.props.freeTrialDaysLeft > 0 && (
                            <Link to="/home">
                                <span className="redirect__link">{`I'll do this later`}</span>
                            </Link>
                        )}
                    </div>
                    <p className="free-trial-date">
                        Get <span className="bold">Personalised</span> data
                    </p>
                    {/* {this.props.packageObj.is_trial_used ? (
                        <h2>Restart you subscription</h2>
                    ) : (
                        <>
                            <h2>Start Your Free 7-Day Trial</h2>
                            <p className="free-trial-date">
                                Your <span className="bold">7-day trial</span> is <span className="bold">Free</span> and lasts until{" "}
                                <span className="bold">{moment().add(6, "days").format("MMMM D, YYYY")}</span>.
                            </p>
                        </>
                    )} */}

                    <p style={{ marginTop: "20px" }}>Organization</p>
                    <div className="selected-plan">
                        <div className="header">
                            <p>{this.props.company.company_name}</p>
                            {this.state.linked_companies.length ? (
                                <div className="switchSection scrollable-list">
                                    <Dropdown
                                        text="Switch Company"
                                        selection
                                        icon="caret down"
                                        className="switch_drdn"
                                        closeOnChange={false}
                                        onBlur={() => this.setState({ searchCompany: "" })}>
                                        <Dropdown.Menu style={{ right: 0, left: "auto", width: "max-content" }}>
                                            <div className="company-menu">
                                                <Dropdown.Item>
                                                    <div className="profile-search">
                                                        <span className="profile-search-icon">
                                                            <SearchIcon />
                                                        </span>
                                                        <input
                                                            type="text"
                                                            onChange={(e) => {
                                                                this.searchCompanyName(e);
                                                            }}
                                                            onKeyUp={(e) => {
                                                                if (e.keyCode === 32) {
                                                                    e.target.value = e.target.value + " ";
                                                                    e.stopPropagation();
                                                                }
                                                            }}
                                                            onClick={(e) => e.stopPropagation()}
                                                            placeholder="Search"
                                                            className="search"
                                                            value={this.state.searchCompany}
                                                        />
                                                        {this.state.searchCompany.length !== 0 && (
                                                            <span
                                                                className="clear-icon"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    this.setState({ searchCompany: "" });
                                                                }}>
                                                                <span className="svg__wrapper">
                                                                    <CloseIcon />
                                                                </span>
                                                            </span>
                                                        )}
                                                    </div>
                                                </Dropdown.Item>
                                                {this.filteredSearch(this.state.linked_companies).map((company, idx) => (
                                                    <Dropdown.Item
                                                        key={company.id}
                                                        title={company.name.length > 50 ? company : null}
                                                        onClick={(e) => {
                                                            if (!company.name.includes("No company found"))
                                                                this.setState({ showModal: true, selectedAccount: company.name });
                                                            else e.stopPropagation();
                                                        }}
                                                        className={company.name == this.props.company.company_name ? "drdn-item selected" : "drdn-item"}>
                                                        {company.name.length > 50 ? company.name.substring(0, 50 - 3) + "..." : company.name}
                                                    </Dropdown.Item>
                                                ))}
                                            </div>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            ) : null}
                        </div>
                    </div>

                    <div className="selected-plan">
                        <div className="header" onClick={() => this.setState({ toggleFeatures: !this.state.toggleFeatures })}>
                            <p>
                                Your <span className="bold">{productNames[this.state.package]}</span> includes these features
                                <Icon name="dropdown" />
                            </p>
                            <Dropdown
                                placeholder="State"
                                selection
                                text="Change Plan"
                                value={this.state.package}
                                onChange={(e, data) => this.setState({ package: data.value })}
                                options={[
                                    { key: "starter", value: "starter", text: "Starter" },
                                    { key: "smb", value: "smb", text: "Professional" },
                                ]}
                            />
                        </div>
                        {this.state.toggleFeatures && <div className="selected-plan-features">{this.getItems()}</div>}
                    </div>

                    <p>Select your billing cycle</p>

                    {this.renderSwitchModal()}

                    <div className="plan-prices">
                        <div
                            className={`plan-price plan-price-annual ${this.state.cycle === "year" ? "active" : ""}`}
                            onClick={() => this.setState({ cycle: "year" })}>
                            <div>
                                <Radio checked={this.state.cycle === "year"} />
                            </div>
                            <div>
                                <p>Annual Subscription</p>
                                <strong>
                                    <p>
                                        US $
                                        {this.props.packages[this.state.package]?.year?.unit_amount
                                            ? (this.props.packages[this.state.package]?.year?.unit_amount / 12).toFixed(0)
                                            : ""}
                                        /month
                                    </p>
                                </strong>
                                <p>Billed annually for US ${this.props.packages[this.state.package]?.year?.unit_amount}</p>
                            </div>
                        </div>
                        <div
                            className={`plan-price plan-price-month ${this.state.cycle === "month" ? "active" : ""}`}
                            onClick={() => this.setState({ cycle: "month" })}>
                            <div>
                                <Radio checked={this.state.cycle === "month"} />
                            </div>
                            <div>
                                <p>Monthly Subscription</p>
                                <strong>
                                    <p>US ${this.props.packages[this.state.package]?.month?.unit_amount}/month</p>
                                </strong>
                                <p>Billed monthly for US ${this.props.packages[this.state.package]?.month?.unit_amount}</p>
                            </div>
                        </div>
                    </div>
                    <p className="faq">
                        {`Have Question?  `}
                        {/* {this.props.packageObj.is_trial_used
                            ? `Have Question? `
                            : `Don’t worry - you will not be charged during the free trial, still have questions? `} */}
                        <span onClick={() => zE("webWidget", "open")}>Chat with us.</span>
                    </p>
                    <div className="action-buttons">
                        <button className="submitButton" onClick={this.checkout}>
                            <span>{this.state.submitting ? <Loader inverted active size="small" /> : "Confirm"}</span>
                        </button>
                        <p>*You will be redirected to Stripe payment gateway</p>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    packages: state.subscriptionReducer.packages,
    packageObj: state.globalReducer.packageObj,
    company: state.globalReducer.company,
    all_companies: state.globalReducer.all_companies,
    newAccessToken: state.globalReducer.newAccessToken,
    freeTrialDaysLeft: state.globalReducer.freeTrialDaysLeft,
});

const mapDispatchToProps = (dispatch) => ({
    fetchPackageDetails: () => dispatch(fetchPackageDetails()),
    getStripeURL: (data) => dispatch(getStripeURL(data)),
    switchAccountDetails: (id) => dispatch(switchAccountDetails(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionPage);
